/** Uniform spinner size (px) for all loading indicators. */
export const SPINNER_SIZE = 40;

/** How long a region waits before the quiet Try again appears under its spinner (Q-494 a, #1561 W3). */
export const REGION_TRY_AGAIN_MS = 15_000;
